import { render, staticRenderFns } from "./ExcludeRanking.vue?vue&type=template&id=70f45a39&scoped=true&"
import script from "./ExcludeRanking.vue?vue&type=script&lang=js&"
export * from "./ExcludeRanking.vue?vue&type=script&lang=js&"
import style0 from "./ExcludeRanking.vue?vue&type=style&index=0&id=70f45a39&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70f45a39",
  null
  
)

export default component.exports